const LOGO = "https://customer-assets.emergentagent.com/job_9b5e32bd-6e03-4600-841f-a63162f850e8/artifacts/w487gkes_lexorbit-logo.png.png";

export default function Footer() {
  const platformLinks = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Sistema', href: '#sistema' },
    { label: 'Seguridad', href: '#seguridad' },
    { label: 'Planes', href: '#planes' },
    { label: 'Demo', href: '#demo' },
    { label: 'Contacto', href: '#contacto' },
  ];
  const legalLinks = [
    { label: 'Política de privacidad', href: '/privacidad' },
    { label: 'Términos y condiciones', href: '/terminos' },
  ];

  return (
    <footer className="relative py-16 lg:py-20 bg-[#050505] border-t border-[rgba(201,164,76,0.08)]" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <img src={LOGO} alt="LexOrbit" className="h-11 mb-4" />
            <p className="text-[#B8B8B8] text-xs leading-relaxed max-w-xs mb-3">
              Plataforma SaaS de gestión jurídica para abogados y estudios profesionales.
            </p>
            <a href="mailto:contacto@lexorbit.com.ar" className="text-[#B8B8B8] text-xs hover:text-[#C9A44C] transition-colors">
              contacto@lexorbit.com.ar
            </a>
          </div>
          <div>
            <h4 className="text-[#F8F6F0] text-xs font-semibold mb-4 uppercase tracking-[0.15em]">Plataforma</h4>
            <ul className="space-y-2">
              {platformLinks.map(l => (
                <li key={l.label}><a href={l.href} className="text-[#B8B8B8] text-xs hover:text-[#C9A44C] transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-[#F8F6F0] text-xs font-semibold mb-4 uppercase tracking-[0.15em]">Legal</h4>
            <ul className="space-y-2">
              {legalLinks.map(l => (
                <li key={l.label}><a href={l.href} className="text-[#B8B8B8] text-xs hover:text-[#C9A44C] transition-colors">{l.label}</a></li>
              ))}
            </ul>
            {/* Data Fiscal AFIP (F960) — obligatorio para operaciones online */}
            <a href="http://qr.afip.gob.ar/?qr=HhAsMyYbmfkcJS8ZtA4UsQ,," target="_F960AFIPInfo" rel="noopener noreferrer"
              className="inline-block mt-5" aria-label="Data Fiscal AFIP">
              <img src="/data-fiscal-afip.jpg" alt="Data Fiscal - AFIP" className="h-14 w-auto" />
            </a>
          </div>
        </div>
        <div className="border-t border-[rgba(201,164,76,0.06)] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#B8B8B8]/40 text-[10px]">2026 LexOrbit. Todos los derechos reservados.</p>
          <p className="text-[#B8B8B8]/30 text-[10px]">Profesionalismo. Seguridad. Orden.</p>
        </div>
      </div>
    </footer>
  );
}
